import root from './_root.js';
'use strict';
/** Used to detect overreaching core-js shims. */


var coreJsData = root['__core-js_shared__'];
export default coreJsData;